import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { Avatar, BackLink, BodyText, Headline, Stack } from '@servicetitan/design-system';
import { tokens } from '@servicetitan/tokens/core';

export interface AppPageHeaderProps {
    id: number;
    publicId: string;
    appName: string;
    deleted: boolean;
    errorBannerVisible: boolean;
}

export const AppPageHeader: FC<AppPageHeaderProps> = ({
    id,
    publicId,
    appName,
    deleted,
    errorBannerVisible,
}) => {
    const history = useHistory();

    return (
        <Stack direction="column">
            <Stack.Item>
                <BackLink
                    pageLabel="My Apps"
                    onClick={() => {
                        history.push(deleted ? '/apps?deleted' : '/apps');
                    }}
                />
            </Stack.Item>
            <Stack.Item>
                {errorBannerVisible ? (
                    <Headline size="large">Error</Headline>
                ) : id > 0 ? (
                    <Stack direction="row" alignItems="center" spacing={1} className="m-t-1">
                        <Avatar icon="devices" size="l" color={tokens.colorPurple400} />
                        <Stack direction="column">
                            <Headline size="large" className="m-b-0">
                                {appName}
                            </Headline>
                            {!errorBannerVisible && id > 0 && (
                                <BodyText size="small" subdued>
                                    {`App ID: ${publicId}`}
                                </BodyText>
                            )}
                        </Stack>
                    </Stack>
                ) : (
                    <Headline size="large">Register New App</Headline>
                )}
            </Stack.Item>
        </Stack>
    );
};
AppPageHeader.displayName = 'AppPageHeader';
